import { Table, TableColumnsType, Tag } from 'antd'
import dayjs from 'dayjs'

import { ONLY_DATE_TIME_FORMAT } from '../../../../constants/global'
import { numberFormat } from '../../../../utils'
import { IStockReportFailureRow } from './types'

interface Props {
  data: IStockReportFailureRow[]
  isLoading?: boolean
}

// not_found  = ยังไม่ได้ผูก SKU นี้กับสินค้าในระบบ → แก้ได้เองที่หน้ารายการสินค้า
// ambiguous  = ผูก SKU เดียวกันไว้กับสินค้าหลายตัว ระบบไม่เดาว่าจะตัดตัวไหน
const REASON_LABEL: Record<string, { text: string; color: string }> = {
  not_found: { text: 'ยังไม่ได้ผูกสินค้า', color: 'orange' },
  ambiguous: { text: 'ผูกซ้ำหลายสินค้า', color: 'red' },
}

const StockDeductionFailureTable = ({ data, isLoading }: Props) => {
  const columns: TableColumnsType<IStockReportFailureRow> = [
    {
      title: 'เวลา',
      dataIndex: 'date',
      key: 'date',
      render: (date?: string) =>
        date ? dayjs(date).format(ONLY_DATE_TIME_FORMAT) : '-',
    },
    {
      title: 'สาเหตุ',
      dataIndex: 'reason',
      key: 'reason',
      render: (reason: string) => {
        const label = REASON_LABEL[reason]
        return <Tag color={label?.color}>{label?.text || reason}</Tag>
      },
    },
    {
      title: 'SKU',
      dataIndex: 'sku',
      key: 'sku',
      render: (sku: string, row) => (
        <div>
          <div>{sku || '-'}</div>
          <div style={{ fontSize: 12, color: '#8c8c8c' }}>
            sku_id: {row.skuId || '-'}
          </div>
        </div>
      ),
    },
    {
      title: 'สินค้าฝั่ง Platform',
      dataIndex: 'productId',
      key: 'productId',
      render: (value: string) => value || '-',
    },
    {
      title: 'คำสั่งซื้อ',
      dataIndex: 'orderId',
      key: 'orderId',
      render: (value: string) => value || '-',
    },
    {
      title: 'จำนวน (ชิ้น)',
      dataIndex: 'quantity',
      key: 'quantity',
      align: 'right',
      render: (value: number) => numberFormat(value, 0),
    },
  ]

  return (
    <Table<IStockReportFailureRow>
      rowKey={(row) =>
        row.objectId || `${row.orderId}-${row.skuId}-${row.date}`
      }
      columns={columns}
      dataSource={data}
      loading={isLoading}
      size="small"
      pagination={{ pageSize: 20, showSizeChanger: false }}
      locale={{ emptyText: 'ไม่มีรายการที่ตัดสต๊อกไม่ได้' }}
    />
  )
}

export default StockDeductionFailureTable
